import { useState, useEffect } from "react";

export default function Nav({ onBuy, bannerOffset = false }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "O livro", href: "#sobre" },
    { label: "Capítulos", href: "#capitulos" },
    { label: "Páginas", href: "#paginas" },
    { label: "Autora", href: "#autora" },
    { label: "Dúvidas frequentes", href: "#faq" },
  ];

  // When the promo banner is visible and the page hasn't been scrolled,
  // push the nav below the banner. Once scrolled, the banner stays at top
  // but the nav slides over it for a clean fixed header experience.
  const topClass = bannerOffset && !scrolled ? "top-[42px] md:top-[44px]" : "top-0";

  return (
    <header
      data-testid="site-header"
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${topClass} ${
        scrolled ? "bg-[#F5F0E8]/95 backdrop-blur-xl border-b border-line" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-lg md:text-xl text-ink"
        >
          Anabela <span className="text-orange">Reis</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-[15px] font-semibold text-ink hover:text-orange transition-colors duration-200 tracking-tight"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          onClick={onBuy}
          data-testid="nav-buy-button"
          className="hidden md:inline-block btn-primary px-5 py-2.5"
        >
          Comprar 29,90€
        </button>
        <button
          className="md:hidden text-ink inline-flex items-center justify-center -mr-2 p-2"
          data-testid="nav-menu-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          style={{ minWidth: 44, minHeight: 44 }}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {open ? <path d="M6 6l12 12M6 18L18 6" /> : <path d="M3 6h18M3 12h18M3 18h18" />}
          </svg>
        </button>
      </div>
      {open && (
        <div className="md:hidden bg-cream border-t border-line px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-ink"
              data-testid={`mobile-nav-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => {
              setOpen(false);
              onBuy();
            }}
            data-testid="mobile-buy-button"
            className="btn-primary px-5 py-3 self-start"
          >
            Comprar — 29,90€
          </button>
        </div>
      )}
    </header>
  );
}
